import { styled } from '@mui/material/styles'
import { Alert, Snackbar } from '@mui/material'
import theme from 'lib/theme'

const chooseTheme = (type: string) => {
  if (type === 'success') {
    return {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.commonColors.white,
    }
  }
  if (type === 'failure') {
    return {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.commonColors.white,
    }
  }

  return {
    backgroundColor: theme.palette.commonColors.darkGrey,
    color: theme.palette.commonColors.white,
  }
}

export const ActionAlert = styled(Alert, {
  shouldForwardProp: (props) => props !== 'type',
})<{ type: string }>(({ type }) => {
  const colors = chooseTheme(type)
  return {
    width: '100%',
    '& .MuiSvgIcon-root': {
      fill: theme.palette.commonColors.white,
    },
    '&.MuiPaper-root': {
      backgroundColor: colors.backgroundColor,
      color: colors.color,
    },
  }
})

export const StyledSnackbar = styled(Snackbar)(() => ({
  '&.MuiSnackbar-anchorOriginBottomRight': {
    right: theme.spacing(1),
    bottom: theme.spacing(1),
  },
  '&.MuiSnackbar-anchorOriginBottomLeft': {
    left: '280px',
    bottom: theme.spacing(1),
  },
  margin: '0 auto',
  width: '460px',
  zIndex: 2000,
  [theme.breakpoints.down('sm')]: {
    width: '94%',
  },
}))
